/******************************************************************************
 * GENERATED by scripts/generateHooks.ts — DO NOT EDIT.
 * Re-run with `pnpm zen3:generate`.
 ******************************************************************************/

/* eslint-disable */

import { useModelQueries, type ModelQueryHooks } from '@zenstackhq/tanstack-query/react';
import { schema } from '../zen3/schema-lite';

type Hooks = ModelQueryHooks<typeof schema, 'User'>;
const hooks = useModelQueries(schema, 'User');

export const useAggregateUser: Hooks['useAggregate'] = hooks.useAggregate;
export const useCountUser: Hooks['useCount'] = hooks.useCount;
export const useCreateUser: Hooks['useCreate'] = hooks.useCreate;
export const useCreateManyUser: Hooks['useCreateMany'] = hooks.useCreateMany;
export const useCreateManyAndReturnUser: Hooks['useCreateManyAndReturn'] = hooks.useCreateManyAndReturn;
export const useDeleteUser: Hooks['useDelete'] = hooks.useDelete;
export const useDeleteManyUser: Hooks['useDeleteMany'] = hooks.useDeleteMany;
export const useExistsUser: Hooks['useExists'] = hooks.useExists;
export const useFindFirstUser: Hooks['useFindFirst'] = hooks.useFindFirst;
export const useFindManyUser: Hooks['useFindMany'] = hooks.useFindMany;
export const useFindUniqueUser: Hooks['useFindUnique'] = hooks.useFindUnique;
export const useGroupByUser: Hooks['useGroupBy'] = hooks.useGroupBy;
export const useInfiniteFindManyUser: Hooks['useInfiniteFindMany'] = hooks.useInfiniteFindMany;
export const useSuspenseAggregateUser: Hooks['useSuspenseAggregate'] = hooks.useSuspenseAggregate;
export const useSuspenseCountUser: Hooks['useSuspenseCount'] = hooks.useSuspenseCount;
export const useSuspenseFindFirstUser: Hooks['useSuspenseFindFirst'] = hooks.useSuspenseFindFirst;
export const useSuspenseFindManyUser: Hooks['useSuspenseFindMany'] = hooks.useSuspenseFindMany;
export const useSuspenseFindUniqueUser: Hooks['useSuspenseFindUnique'] = hooks.useSuspenseFindUnique;
export const useSuspenseGroupByUser: Hooks['useSuspenseGroupBy'] = hooks.useSuspenseGroupBy;
export const useSuspenseInfiniteFindManyUser: Hooks['useSuspenseInfiniteFindMany'] = hooks.useSuspenseInfiniteFindMany;
export const useUpdateUser: Hooks['useUpdate'] = hooks.useUpdate;
export const useUpdateManyUser: Hooks['useUpdateMany'] = hooks.useUpdateMany;
export const useUpdateManyAndReturnUser: Hooks['useUpdateManyAndReturn'] = hooks.useUpdateManyAndReturn;
export const useUpsertUser: Hooks['useUpsert'] = hooks.useUpsert;
